import { useCallback,useEffect, useState } from "react";

interface UseCountdownReturn {
  timeLeft: string;
  isComplete: boolean;
  reset: () => void;
}

export const useCountdown = (
  initialSeconds: number = 60,
  isInitiallyPaused: boolean = false,
  onComplete?: () => void
): UseCountdownReturn => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const [isComplete, setIsComplete] = useState(false);
  const [isPaused, setIsPaused] = useState(isInitiallyPaused);

  const reset = useCallback(() => {
    setIsPaused(false);
    setSeconds(initialSeconds);
    setIsComplete(false);
  }, [initialSeconds]);

  useEffect(() => {
    if (isPaused) return;
    if (seconds <= 0) {
      setIsComplete(true);
      onComplete?.();
      return;
    }

    const timer = setInterval(() => {
      setSeconds(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds, onComplete, isPaused]);

  const formatTime = (totalSeconds: number): string => {
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return {
    timeLeft: formatTime(seconds),
    isComplete,
    reset,
  };
};
